import { Modal } from "@windmill/react-ui";
import React, { useContext, useState, useEffect } from "react";
import { FiX } from "react-icons/fi";
import { SidebarContext } from "../../context/SidebarContext";
import useBusinessSubmit from "../../hooks/formSubmits/useBusinessSubmit";
import AboutBusiness from "../onBoarding/AboutBusiness";
import DepartmentSelection from "../onBoarding/DepartmentSelection";
import AiSuggestedReports from "../onBoarding/AiSuggestedReports";
import AddBusinessName from "../onBoarding/AddBusinessName";
import NewWorkspaceWelcome from "../onBoarding/NewWorkspaceWelcome";

export default function CreateStore() {
  const { create, setCreate } = useContext(SidebarContext);
  const [step, setStep] = useState(1);
  const [teamData, setTeamData] = useState({
    name: "",
    description: "",
    reg_channel: "web",
    business_type: "",
  });

  const handleClose = () => {
    setCreate(false);
    setStep(5);
  };
  const { onSubmit, isLoading } = useBusinessSubmit({ handleClose });

  const handleCreateSubmit = async () => {
    await onSubmit(teamData);
  };

  return (
    <>
      <Modal
        isOpen={create}
        onClose={handleClose}
        style={{
          padding: 0,
          width: "100vw",
          minWidth: "100vw",
          height: "100vh",
          overflow: "scroll",
        }}
      >
        <button
          onClick={handleClose}
          type="button"
          className="absolute focus:outline-none z-50 flex lg:mr-16 mr-4 mt-8 lg:text-base text-sm font-semibold items-center gap-1 hover:text-gray-700  text-red-500 hover:bg-red-100  transition-colors duration-150   right-0 left-auto  rounded px-4  text-center"
        >
          <FiX className="mx-auto" /> close
        </button>
        <div>
          {step === 1 && <NewWorkspaceWelcome setStep={setStep} />}
          {step === 2 && (
            <AboutBusiness
              setStoreData={setTeamData}
              setStep={setStep}
              storeData={teamData}
            />
          )}
          {step === 3 && (
            <DepartmentSelection
              setStoreData={setTeamData}
              storeData={teamData}
              step={step}
              setStep={setStep}
            />
          )}
          {step === 4 && (
            <AddBusinessName
              setStoreData={setTeamData}
              storeData={teamData}
              step={step}
              setStep={setStep}
              onSubmit={handleCreateSubmit}
              isLoading={isLoading}
            />
          )}

          {step === 5 && (
            <div className="min-h-screen bg-green-50 flex justify-center items-center px-3">
              <AiSuggestedReports
                storeData={teamData}
                setStep={setStep}
                onComplete={() => ({})}
              />
            </div>
          )}
        </div>
      </Modal>
    </>
  );
}
